import type { RouteObject } from "react-router-dom";
import { useParams } from "react-router-dom";
import { StoreSettingsPage } from "./pages/StoreSettingsPage";

function StoreSettingsRoute() {
  const { storeSlug = "" } = useParams();

  return <StoreSettingsPage storeSlug={storeSlug} />;
}

export const settingsRoutes: RouteObject[] = [
  {
    path: "settings",
    element: <StoreSettingsRoute />,
  },
];
